<template>
  <div class="text-center div_btn_inline">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="idAccion == 1"
          color="success" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
          Agregar encuesta
        </v-btn>
      </template>
<span>Agregar Encuesta</span>
</v-tooltip>

<v-tooltip bottom>
  <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="idAccion == 2"
          icon 
          color="info" 
          class="px-0"
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
  <span>Editar Encuesta</span>
</v-tooltip>

<v-dialog :name="'dialog_form_servicio_' + idEncuesta" :key="'dialog_form_servicio_' + idEncuesta" v-model="dialog"
  fullscreen hide-overlay transition="dialog-bottom-transition">
  <v-card>
    <v-toolbar dark color="primary" name="toolbar_dialog_form_servicio">
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <v-icon color="white">{{ idAccion == 1 ? 'mdi-plus' : 'mdi-pencil' }}</v-icon>
        {{ idAccion == 1 ? 'Agregar Encuesta' : 'Editar Encuesta' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="dialog = false">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card-text>
      <v-form class="mt-5 my-5" ref="form" v-model="valid" :lazy-validation="lazy">
        <v-row>
          <v-col cols="12" md="8" class="px-8">
            <v-card color="#A0935F" dark class="mb-4">
              <v-card-title class="headline">
                <v-icon class="mr-2">mdi-information</v-icon>
                Información de la Encuesta
              </v-card-title>
            </v-card>
            <v-row>
              <v-col cols="12">
                <select-servicios :id-cat-servicio-prop="idCatServicio" :fn-change="setIdCatServicio"
                  :requerido="true"></select-servicios>
              </v-col>
              <!-- <v-col cols="12" md="6">
                    <select-sistema :id-sistema-prop="idSistemaEncuesta" :fn-change="setIdSistemaEncuesta" :requerido="false"></select-sistema>
                  </v-col> -->
            </v-row>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field v-model="nombreEncuesta" :loading="loading" label="Nombre de la Encuesta *"
                  :rules="[(v) => !!v || 'Campo obligatorio']" outlined dense required></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input v-model="imgEncabezado" :loading="loading || loadingImg" label="Imagen encabezado"
                  outlined dense accept="image/*"></v-file-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea v-model="objetivo" :loading="loading" label="Objetivos"
                  :rules="[(v) => !!v || 'Campo obligatorio']" outlined required dense auto-grow></v-textarea>
                <v-textarea v-model="alcanceEncuesta" :loading="loading" label="Alcance"
                  :rules="[(v) => !!v || 'Campo obligatorio']" outlined required dense auto-grow></v-textarea>
                <v-textarea v-model="pieEncuesta" :loading="loading" label="Pie encuesta"
                  :rules="[(v) => !!v || 'Campo obligatorio']" outlined required dense auto-grow></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                      :value=getDateFormated(date)
                        label="Fecha Inicio"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        clearable
                        @click:clear="date = null"
                      ></v-text-field>
                      
                    </template>
                  <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value=getDateFormated(date2)
                        label="Fecha Fin"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        clearable
                        @click:clear="date2 = null"
                      ></v-text-field>
                      
                    </template>
                  <v-date-picker v-model="date2" @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="2">
                <v-switch v-model="sinCaducidad" class="mx-2" label="Sin caducidad" required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch v-model="conAutenticacion" class="mx-2" label="Con autenticación" required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-switch v-model="requiereParametros" class="mx-2" label="Requiere Parámetros" required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch v-model="habilitada" class="mx-2" label="Habilitada" required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-switch v-model="envioCorreo" class="mx-2" label="Envio de Correos" required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details></v-switch>
              </v-col>

            </v-row>
          </v-col>
          <v-col cols="12" md="4" class="px-8">
            <v-card color="#A0935F" dark class="mb-4">
              <v-card-title class="headline">
                <v-icon class="mr-2">mdi-account-circle</v-icon>
                Información del Ámbito
              </v-card-title>
            </v-card>

            <v-row>
              <v-col cols="12" md="12">
                <select-tipo-ambitos :id-ambito-prop="idAmbito" :fn-change="setTipoAmbito"
                  :requerido="true"></select-tipo-ambitos>


              </v-col>
              <v-col cols="12" md="12">
                <select-ambitos :id-ambito="idAmbito" :id-pk-ambito-prop="idPkAmbito" :fn-change="setIdAmbito"
                  :requerido="true"></select-ambitos>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea v-model="nombreAmbito" label="Nombre Ambito" readonly outlined auto-grow></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="12">


                <v-switch v-model="catalogoInstitucional" class="mx-2" label="Mostrar catálogos institucionales "
                  required style="justify-content: center; display: grid;  margin-top:5px;" hide-details
                  @change="(value) => changeStateCatalogoInstitucional(value)"></v-switch>

                <v-textarea v-if="catalogoInstitucional" v-model="textoCatalogoInstitucional" :loading="loading"
                  label="Colocar el mensaje a mostrar en la encuesta" :rules="[(v) => !!v || 'Campo obligatorio']"
                  outlined required dense auto-grow></v-textarea>

                <v-switch v-if="catalogoInstitucional" v-model="campus" class="mx-2" label="Campus" required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details
                  @change="(value) => changeStateCampus(value)"></v-switch>
              </v-col>

              <v-col cols="1" md="12">
                <v-switch v-if="campus && catalogoInstitucional" v-model="division" class="mx-2" label="División" required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details
                  @change="(value) => changeStateDivision(value)"></v-switch>
              </v-col>
              <v-col cols="1" md="12">
                <v-switch v-if="division && campus && catalogoInstitucional" v-model="departamento" class="mx-2"
                  label="Departamento" required style="justify-content: center; display: grid;  margin-top:5px;"
                  hide-details></v-switch>
              </v-col>

              <v-col cols="1" md="12">
                <v-switch v-model="catalogoDistribucionTerritorial" class="mx-2"
                  label="Mostrar catálogos de información territorial " required
                  style="justify-content: center; display: grid;  margin-top:5px;" hide-details></v-switch>
                <v-textarea v-if="catalogoDistribucionTerritorial" v-model="textoCatalogoDistribucionTerritorial"
                  :loading="loading" label="Colocar el mensaje a mostrar en la encuesta"
                  :rules="[(v) => !!v || 'Campo obligatorio']" outlined required dense auto-grow></v-textarea>
              </v-col>
              <v-col cols="12" md="12">
              </v-col>
            </v-row>


          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <small>* Campo obligatorio</small>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn large color="success" :disabled="!valid" :loading="loadingSave" @click="guardar">
              <v-icon class="mr-2">mdi-floppy</v-icon>
              guardar encuesta
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</v-dialog>

<v-snackbar :name="'snackbar_dialog_form_encuesta_' + idEncuesta" :key="'snackbar_dialog_form_encuesta_' + idEncuesta"
  v-model="snackbar" :bottom="true" :multi-line="true" :color="snackbarColor">
  {{ snackbarTexto }}
  <v-btn dark text @click="snackbar = false">
    Cerrar
  </v-btn>
</v-snackbar>
</div>
</template>

<script>
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import { postEncuesta, putEncuesta, getEiArchivoByNombreTablaIdEi } from "@/api";
export default {
  name: "DialogFormEncuesta",
  components: {
    SelectCatClasificacionProceso: () => import("../comunes/SelectCatClasificacionProceso"),
    SelectServicios: () => import("../comunes/SelectServicios"),
    //SelectSistema: () => import("../comunes/SelectSistema"),
    SelectAmbitos: () => import("../comunes/SelectAmbitos"),
    SelectCampus: () => import("../comunes/SelectCampus"),
    BuscadorEmpleado: () => import("../comunes/BuscadorEmpleado"),
    selectTipoAmbitos:()=>import("../comunes/SelectTipoAmbitos"),
  },
  props: {
    idAccion: {
      type: Number,
      required: true
    },
    objEncuesta: {
      type: Object,
      default: function () {
        return {
          idEncuesta: 0,
          idCatServicio:null,
          idSistemaEncuesta:null,
          nombreEncuesta: '',
          objetivo: null,
          conAutenticacion:false,
          fechaInicio: null,
          fechaFin: null,
          sinCaducidad:false,
          idAmbito: null,
          ambito:null,
          idPkAmbito:null,
          nombreAmbito:null,
          fechaRegistro:null,
          fechaActualizacion:null,
          habilitada: false,
          envioCorreo:false,
          requiereParametros: false,   
          habilitadaDsi: false,
          tokenEncuesta:'bf9ec86f-5444-4ffb-bb5b-f2a2709df5f1',
          pieEncuesta:null, 
          alcanceEncuesta:null,
          catalogoInstitucional:false,
          campus:false,
          division:false,
          departamento:false,
          catalogoDistribucionTerritorial:false,
          textoCatalogoDistribucionTerritorial:null,
          textoCatalogoInstitucional:null,
          
        }
      }
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    }
  },
  data() {
     
    return {
      dialog: false,
      loading: false,
      loadingImg: false,
      loadingSave: false,
      valid: false,
      lazy: false,
      flagInitForm: 1,
      idAccionForm: 1,
      idEncuesta: 0,
      idCatServicio:null,
      idSistemaEncuesta:null,
      nombreEncuesta: '',
      objetivo: null,
      conAutenticacion:false,
      fechaInicio: null,
      fechaFin: null,
      sinCaducidad:false,
      idAmbito: null,
      ambito:null,
      idPkAmbito:null,
      nombreAmbito:null,
      fechaRegistro:null,
      fechaActualizacion:null,
      habilitada: false,
      requiereParametros: false,   
      habilitadaDsi: false,
      envioCorreo:false,
      tokenEncuesta:null,    
      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",
      banLimpiarDatos: 0,
       clave: null,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      menu1: false,
      imgEncabezado: null,
      pieEncuesta:null,
      alcanceEncuesta:null,
      catalogoInstitucional:false,
      campus:false,
      division:false,
      departamento:false,
      catalogoDistribucionTerritorial:false,
      textoCatalogoDistribucionTerritorial:null,
      textoCatalogoInstitucional:null,
          
    };
  },
  computed: {
  },
  watch:{
    dialog: {
      handler (newValue, oldValue) {
        if(this.$refs.form != undefined && newValue == true){
          this.$refs.form.resetValidation();
        }
        if(newValue == true){
          this.idEncuesta = this.objEncuesta.idEncuesta;
          this.idCatServicio=this.objEncuesta.idCatServicio;
          this.idSistemaEncuesta=this.objEncuesta.idSistemaEncuesta;
          this.nombreEncuesta = this.objEncuesta.nombreEncuesta;
          this.objetivo=this.objEncuesta.objetivo;
          this.conAutenticacion=this.objEncuesta.conAutenticacion;
          if(this.objEncuesta.fechaInicio==null){
          this.date=this.objEncuesta.fechaInicio;  
          }
          else{
            this.date=this.objEncuesta.fechaInicio.substr(0,10);
          }
          if(this.objEncuesta.fechaFin==null){
             this.date2=this.objEncuesta.fechaFin;
          }
          else{
            this.date2=this.objEncuesta.fechaFin.substr(0,10);
          }
          this.sinCaducidad=this.objEncuesta.sinCaducidad;
          this.idAmbito=this.objEncuesta.idAmbito;
          this.ambito=this.objEncuesta.ambito;
          this.idPkAmbito=this.objEncuesta.idPkAmbito;
          this.nombreAmbito=this.objEncuesta.nombreAmbito;
          this.fechaRegistro=this.objEncuesta.fechaRegistro;
          this.fechaActualizacion=this.objEncuesta.fechaActualizacion;
          this.habilitada=this.objEncuesta.habilitada;
          this.requiereParametros=this.objEncuesta.requiereParametros;
          this.habilitadaDsi=this.objEncuesta.habilitadaDsi;
          this.tokenEncuesta=this.objEncuesta.tokenEncuesta;
          this.envioCorreo=this.objEncuesta.envioCorreo;
          this.pieEncuesta=this.objEncuesta.pieEncuesta;
          this.alcanceEncuesta=this.objEncuesta.alcanceEncuesta;
          this.catalogoInstitucional=this.objEncuesta.catalogoInstitucional;
          this.campus=this.objEncuesta.campus;
          this.division=this.objEncuesta.division;
          this.departamento=this.objEncuesta.departamento;
          this.catalogoDistribucionTerritorial=this.objEncuesta.catalogoDistribucionTerritorial;
          this.textoCatalogoInstitucional=this.objEncuesta.textoCatalogoInstitucional;
          this.textoCatalogoDistribucionTerritorial=this.objEncuesta.textoCatalogoDistribucionTerritorial;
          
          if(this.objEncuesta.idEncuesta != 0 ){
            this.obtenerEiArchivoImgEncabezado();
          }
        }
        else{
          this.idEncuesta= 0;
          this.idCatServicio=null;
          this.idSistemaEncuesta=null;
          this.nombreEncuesta= '';
          this.objetivo= '';
          this.conAutenticacion=false;
          this.fechaInicio= '';
          this.fechaFin= '';
          this.sinCaducidad=false;
          this.idAmbito=null;
          this.ambito=null;
          this.idPkAmbito=null;
          this.nombreAmbito='';
          this.fechaRegistro='';
          this.fechaActualizacion='';
          this.habilitada=false;
          this.requiereParametros= false;   
          this.habilitadaDsi= false;
          this.envioCorreo=false;
          this.tokenEncuesta='00000000-0000-0000-0000-000000000000';
          this.pieEncuesta='';
          this.alcanceEncuesta='';  
          this.catalogoInstitucional=false;
          this.campus=false;
          this.division=false;
          this.departamento=false; 
          this.catalogoDistribucionTerritorial=false;
          this.textoCatalogoDistribucionTerritorial=null;
          this.textCatalogoInstitucional=null;
       }
			},
    }
  },
  beforeMount(){
  },
  mounted() {
  },
  methods: {
    changeStateCatalogoInstitucional(valor) {
      this.catalogoInstitucional=valor;
        if(valor==false){
          this.campus=false;
          this.division=false;
          this.departamento=false;
        }},
        changeStateCampus(valor) {
      this.campus=valor;
        if(valor==false){
          this.division=false;
          this.departamento=false;
        }},
        changeStateDivision(valor) {
      this.division=valor;
        if(valor==false){
          this.departamento=false;
        }
     
    },
    async obtenerEiArchivoImgEncabezado () {
      var self = this;
      self.loadingImg = true;
      self.imgEncabezado = null;      
      self.snackbarError = false;
      self.textoError = "";
      try {
        let response = await getEiArchivoByNombreTablaIdEi('EI_ENCUESTA', self.objEncuesta.idEncuesta);
        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              if(response.data.data != null){
                this.imgEncabezado = new File([response.data.data.docto], response.data.data.nombreArchivo, {
                                                type: response.data.data.contenttype,
                                              })
              }
              self.loadingImg = false;
            }
          } else {
            self.snackbarTexto = "DialogFormEncuesta.obtenerEiArchivoImgEncabezado: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loadingImg = false;
          }
        } else {
          self.snackbarTexto = "DialogFormEncuesta.obtenerEiArchivoImgEncabezado: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loadingImg = false;
        }
      } catch (e) {
        self.loadingImg = false;
        self.snackbarTexto = "DialogFormEncuesta.obtenerEiArchivoImgEncabezado: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    async guardar(){
      var self = this;
      if (self.$refs.form.validate()) {
        self.loadingSave = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";
        try {
          let response;
          var obj = {
      idEncuesta: this.idEncuesta,
      idCatServicio:this.idCatServicio,
      idSistemaEncuesta:this.idSistemaEncuesta,
      nombreEncuesta:this.nombreEncuesta,
      objetivo: this.objetivo,
      conAutenticacion:this.conAutenticacion,
      fechaInicio: this.date,
      fechaFin: this.date2,
      sinCaducidad:this.sinCaducidad,
      idAmbito: this.idAmbito,
      ambito:this.ambito,
      idPkAmbito:this.idPkAmbito,
      nombreAmbito:this.nombreAmbito,
      fechaRegistro:this.fechaRegistro,
      fechaActualizacion:this.fechaActualizacion,
      habilitada: this.habilitada,
      requiereParametros: this.requiereParametros,   
      habilitadaDsi: this.habilitadaDsi,
      envioCorreo:this.envioCorreo,
      tokenEncuesta:this.tokenEncuesta,
      pieEncuesta:this.pieEncuesta,
      alcanceEncuesta:this.alcanceEncuesta,
      catalogoInstitucional:this.catalogoInstitucional,
      campus:this.campus,
      division:this.division,
      departamento:this.departamento,
      catalogoDistribucionTerritorial:this.catalogoDistribucionTerritorial,
      textoCatalogoDistribucionTerritorial:this.textoCatalogoDistribucionTerritorial,
      textoCatalogoInstitucional:this.textoCatalogoInstitucional
      }
          if(obj.idEncuesta == 0){
            response = await postEncuesta(obj, this.imgEncabezado);
          }
          else{
            response = await putEncuesta(obj, this.imgEncabezado);
          }
          if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Guardado correcto") {
                self.snackbarTexto = "Encuesta guardada con éxito";
                self.snackbarColor = "success";
                self.snackbar = true;
                self.fnOnSave();
                self.dialog = false;
              }
            } else {
              self.snackbarTexto = "DialogFormEncuesta: " + response.data.message;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto = "DialogFormEncuesta: Error de red";
            self.snackbarColor = "error";
            self.snackbar = true;
          }
          self.loadingSave = false;
        } catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "DialogFormEncuesta: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
      }
    },
     setTipoAmbito(objAmbitoo){
      this.idAmbito = objAmbitoo.idAmbito;
      this.ambito = objAmbitoo.clave;
    },
    setIdAmbito(objAmbito){
      this.idPkAmbito=objAmbito.idPkAmbito;
      this.nombreAmbito=objAmbito.nombreAmbito;
      this.ambito=objAmbito.ambito;
    },
    setIdCatServicio(objServicio){
      this.idCatServicio = objServicio.idCatServicio;
    },
    setIdSistemaEncuesta(objSistema){
      this.idSistemaEncuesta = objSistema.idSistemaEncuesta;
    },
    setClasificacionProceso(descClasifProceso){
      this.clasificacionProceso = descClasifProceso;
    },
    getDateFormated(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      }
    },
  },  
};
</script>